
import React from 'react';
import { Button } from '@/components/ui/button';

interface MicrosoftAuthButtonProps {
  onClick: () => Promise<void>;
}

const MicrosoftAuthButton: React.FC<MicrosoftAuthButtonProps> = ({ onClick }) => {
  return (
    <Button 
      type="button" 
      className="w-full bg-[#2F2F2F] hover:bg-[#1E1E1E] text-white flex items-center justify-center gap-2"
      onClick={onClick}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 23 23" fill="none">
        <path d="M11 0H0V11H11V0Z" fill="#F25022"/>
        <path d="M23 0H12V11H23V0Z" fill="#7FBA00"/>
        <path d="M11 12H0V23H11V12Z" fill="#00A4EF"/>
        <path d="M23 12H12V23H23V12Z" fill="#FFB900"/>
      </svg>
      Sign in with Microsoft
    </Button>
  );
};

export default MicrosoftAuthButton;
